import { useEffect, useState } from "react"
import { HeadingRow, ButtonRow, Button, FormManager, FormTextInput, FormNumberInput, ContextMenuItem } from "cai-fusion"

import { ReactComponent as IconSpark } from "../../../../../images/icon-spark.svg"
import { ReactComponent as IconApproved } from "../../../../../images/icon-approved.svg"
import { ReactComponent as IconRename } from "../../../../../images/icon-rename.svg"
import { useSiftV2 } from "../../../contexts/siftV2Context"
import { debugLog } from "../../../../../configs/loggingConfig"

const SiftOpportunityInfoBlock = ({infoObj}) => {

    const { currOpp, updateFields } = useSiftV2();

    const [isEditing, setIsEditing] = useState(false);
    const [placeholderKeyInfo, setPlaceholderKeyInfo] = useState({
        "stuff": "hi",
        "this": "what",
        "fields": [
            { "name": "Opportunity Owner", "value": "French A L'Or", "isAI": true,},
            { "name": "Opportunity Owner 2", "value": "German A L'And", "isAI": false,},
            { "name": "Cost", "value": "$500,000", "isAI": true,},
        ]
    });

    
    const [formObj, setFormObj] = useState([]);

    useEffect(() => {
        debugLog.log("[SIFTV2] Opportunity updated, refreshing input fields...")
        if (currOpp?.request?.currentState?.form?.questions?.length > 0) {
            setFormObj([...currOpp?.request?.currentState?.form?.questions.filter((question) => question.questionType !== 1).map((field) => ({...field, "isEditing": false}))])
            // debugLog.log("test2", [...currOpp?.request?.currentState?.form?.questions.filter((question) => question.questionType !== 1).map((field) => ({...field, "isEditing": false}))]);
        }
    }, [currOpp])

    const onInputChange = (questionId, questionType, value) => {
        if (questionType === 8) {
            setFormObj([...formObj.map((field) => field.questionId !== questionId ? {...field} : {...field, "answers": [{...field.answers[0], "selectedDate": value}, ...field.answers.slice(1)], "isAI": false, "edited": true})]);
        } else {
            setFormObj([...formObj.map((field) => field.questionId !== questionId ? {...field} : {...field, "answers": [{...field.answers[0], "text": value}, ...field.answers.slice(1)], "isAI": false, "edited": true})]);
        }
    }

    const nowEditing = (questionId) => {
        // This is a "personal" isEditing, used to make this field an input rather than a display.
        setFormObj([...formObj.map((field) => field.questionId !== questionId ? {...field} : {...field, "isEditing": true})]);
        // This is a "global" isEditing, used to show the Save button at the bottom.
        setIsEditing(true);
    }

    const allEditing = () => {
        setFormObj([...formObj.map((field) => ({...field, "isEditing": true}))]);
        setIsEditing(true);
    }

    const confirmField = (questionId) => {
        setFormObj([...formObj.map((field) => field.questionId !== questionId ? {...field} : {...field, "isAI": false})]);
    }

    const saveFields = () => {
        setFormObj([...formObj.map((field) => ({...field, "isEditing": false}))]);
        let changedFields = formObj.filter((item) => item.edited);
        updateFields(changedFields);
        setIsEditing(false);
    }

    return (
        <div className="o-block l-mb-sm">
            <HeadingRow 
                isSecondary
                title="Key Info"
                size={3}
            >
                <ButtonRow>
                    {!isEditing && <Button outline size="small" children="Edit" onClick={allEditing} />}
                    {isEditing && <Button size="small" children="Save" onClick={saveFields} />}
                </ButtonRow>
            </HeadingRow>
            <div className="o-form l-mt-xs">
                <div className="row">
                    <div className="col-md-6">
                        {formObj?.map((field, index) => (index % 2 === 0 &&
                            <FieldItem 
                                key={index}
                                isEdit={field?.isEditing}
                                isAI={field?.isAI}
                                fieldObj={field}
                                setEditing={() => nowEditing(field?.questionId)}
                                confirmField={() => confirmField(field?.questionId)}
                                onInputChange={(questionId, value) => onInputChange(questionId, field?.questionType, value)}
                            />
                        ))}
                    </div>
                    <div className="col-md-6">
                        {formObj?.map((field, index) => (index % 2 !== 0 &&
                            <FieldItem 
                                key={index}
                                isEdit={field?.isEditing}
                                isAI={field?.isAI}
                                fieldObj={field}
                                setEditing={() => nowEditing(field?.questionId)}
                                confirmField={() => confirmField(field?.questionId)}
                                onInputChange={(questionId, value) => onInputChange(questionId, field?.questionType, value)}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}


const FieldItem = ({fieldObj, isAI = false, isEdit, onInputChange, setEditing, confirmField}) => {

    const extractFieldValue = (fieldObj, formatDate = false) => {
        const ans = fieldObj.answers[0]
        if (fieldObj.questionType !== 8 && ans.text) return ans.text
        if (ans.selectedDate && ans.selectedDate !== '0001-01-01T00:00:00') {
            return formatDate ? new Date(ans.selectedDate).toLocaleDateString() : ans.selectedDate
        }
        else return null;
    }

    const [hideContextMenu, setHideContextMenu] = useState(true);
  
    return (
        <div className="m-form-group">
            {!isEdit ?
                <>
                    <label className={`a-label ${isAI ? "a-label--ai" : ""}`}>
                        {`${fieldObj?.questionText} `}
                        {isAI && <IconSpark className="a-icon a-icon--ai a-icon--x-small svg-inject"/>}
                    </label>
                    {isAI && 
                        <div className="m-citation-wrapper js-citation-wrapper js-has-ai-citation" onBlur={(e) => {
                            e.preventDefault();
                            if (!e.currentTarget.contains(e.relatedTarget)) {
                                setHideContextMenu(true);
                            }
                        }}>
                            <div className={`o-button-context-menu ${!hideContextMenu && "o-button-context-menu--shown"}`}>
                                <button className="a-read-only-value a-read-only-value--ai o-button-context-menu__toggle-button"
                                    onClick={() => setHideContextMenu(!hideContextMenu)}
                                >
                                    {extractFieldValue(fieldObj, true)}
                                </button>
                                <ul className="m-context-menu o-button-context-menu__menu">
                                    <ContextMenuItem
                                        Icon={IconApproved} 
                                        name="Confirm"
                                        onClick={() => {
                                            setHideContextMenu(true);
                                            confirmField();
                                        }}
                                    />
                                    <ContextMenuItem 
                                        Icon={IconRename} 
                                        name="Modify"
                                        onClick={() => {
                                            setHideContextMenu(true);
                                            setEditing();
                                        }}
                                    />
                                </ul>
                            </div>
                        </div>
                    }
                    {!isAI && <p className="a-read-only-value">{extractFieldValue(fieldObj, true)} </p>}
                </>
            : 
                <FormTextInput 
                    displayName={fieldObj?.questionText}
                    formValue={extractFieldValue(fieldObj)}
                    onInputChange={(fieldId, newValue) => onInputChange(fieldObj?.questionId, newValue)}
                />
            }
        </div>
    )
}

export default SiftOpportunityInfoBlock;